// src/services/offboardingService.js
// Bug 06 fix: approve method add kiya gaya — SuperAdmin offboarding approve kare.

import { api } from './api';

export const offboardingService = {
  initiate: (data) => api.post('/api/offboarding/', data),

  getAll: (status) => {
    const qs = status ? '?status=' + status : '';
    return api.get('/api/offboarding/' + qs);
  },

  getOne: (id) => api.get('/api/offboarding/' + id),

  updateChecklist: (offboardingId, data) =>
    api.put('/api/offboarding/' + offboardingId + '/checklist', data),

  // Bug 06 fix: SuperAdmin approve endpoint call
  approveOffboarding: (offboardingId) =>
    api.put('/api/offboarding/' + offboardingId + '/approve', {}),

  updateLetterDraft: (offboardingId, letterBody) =>
    api.put('/api/offboarding/' + offboardingId + '/experience-letter/draft', { letter_body: letterBody }),

  generateLetter: (offboardingId) =>
    api.post('/api/offboarding/' + offboardingId + '/experience-letter/generate', {}),

  getDownloadUrl: (offboardingId) => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
    return baseUrl + '/api/offboarding/' + offboardingId + '/experience-letter/download';
  },

  cancelOffboarding: (offboardingId) =>
    api.put('/api/offboarding/' + offboardingId + '/cancel', {}),
};